module.exports = __webpack_public_path__ + "static/assets/10299cfdb7aae4ef46933f78b4366d6f.png";